module.exports = __webpack_public_path__ + "media/images/icons/bi-logo-full-white-985a9044e7292f1df3f01bbc0fbb7fd6.svg";